import { Component, OnDestroy } from '@angular/core';
import { BlahService } from '@headpower/blah-ng';

import { LiveMessagingService } from '@headpower/layout';
import { Subject, takeUntil } from 'rxjs';

import { MapPinItem } from '../map/map.component';


@Component({
  selector: 'app-status-screen',
  templateUrl: './status-screen.component.html',
  styleUrls: [
    './status-screen.component.css'
  ]
})
export class StatusScreenComponent implements OnDestroy {

  private operationTopic = 'iwm/statusScreen/**';

  public mapItems: MapPinItem[] = [];

  private destroy$: Subject<void> = new Subject();

  constructor(
    private liveMessagingService: LiveMessagingService,
    private blahService: BlahService,
  ) {

    this.liveMessagingService.listenToSingleMessages(this.operationTopic)
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        this.createMarker(result.Payload.EventId, result.Payload.Lat, result.Payload.Lon, result.Payload.Operation, this.getTargetType(result.Topic));
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private getTargetType(topic: string): string {
    let target = 'Task';
    if (topic && topic.startsWith('iwm/statusScreen/worksite')) {
      target = 'Worksite';
    }
    return target;
  }

  private createMarker(id: string, lat: number, lon: number, operation: string, targetType: string) {
    if (lat == null) {
      lat = 0;
    }

    if (lon == null) {
      lon = 0;
    }

    // Only display tasks with location
    if (lat == 0 && lon == 0) {
      return;
    }

    const title = operation === 'open'
      ? this.blahService.blah('map.statusMap.actions.open' + targetType)
      : this.blahService.blah('map.statusMap.actions.editTask');

    const color = operation === 'open' ? 'green' : 'red';
    id = new Date().getTime().toString();

    const newItem = <MapPinItem>{
      Id: id,
      Lat: lat,
      Lon: lon,
      Color: color,
      Title: `<div class="mat-typography"><p>${title}</p></div>`,
      Properties: { Active: true }

    };
    let array = [];
    array.push(newItem);
    this.mapItems.forEach(o => array.push(o));
    this.mapItems = array;

    // remove marker after 5 minutes
    setTimeout(() => {
      newItem.Properties.Active = false;
      this.removeExpiredMarkers()
    }, 5 * 60 * 1000);
  }

  private removeExpiredMarkers() {
    this.mapItems = this.mapItems.filter(o => o.Properties.Active);
  }
}
